import { Pipe, PipeTransform } from '@angular/core';
import { WarningStatusDetails } from '@dpr-details/enums';
import { DprActivityGridData } from '@dpr-details/models/grid';

@Pipe({ name: 'warningStatusTooltip' })
export class WarningStatusTooltipPipe implements PipeTransform {
  transform(data: DprActivityGridData): string {
    return data?.status ? WarningStatusDetails.get(data.status)?.text : null;
  }
}
